import * as React from 'react';
import * as styles from '../SiteSelector.css';
import { IContentOrganizerCreate } from '../../../interfaces/IContentOrganizerCreate';
import { Helper } from '../../../Helper';

export interface ISiteItemProps {
  contentOrganizerInstance: Partial<IContentOrganizerCreate>;
  isSelected: boolean;
  highlightColor: string;
  onClick: () => void;
}

export class IASiteItem extends React.Component<ISiteItemProps> {
  constructor(props: ISiteItemProps) {
    super(props);
  }

  public render() {
    return <div
      onClick={() => this.props.onClick()}
      className={styles.IA_siteItem}
      style={{
        backgroundColor: this.props.isSelected ? this.props.highlightColor : "#eee",
        color: this.props.isSelected ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.highlightColor, "white", "#4f4e4d") : "#4f4e4d"
      }}
    >
      <b>{this.props.contentOrganizerInstance.title}</b><br />
      {this.props.contentOrganizerInstance.siteCollection}
    </div>
  }
}